import { Popover, PopoverTrigger, PopoverSurface, Link, makeStyles, tokens, Text, Badge } from "@fluentui/react-components";
import { SettlementDebt } from "../../../models/Entities/SettlementDebt/SettlementDebt";

interface SettlementDebtsInfoProps {
    SettlementDebts: SettlementDebt[];
}

const useStyles = makeStyles({
    surface: {
        maxWidth: '420px',
    },
    title: {
        display: 'block',
        fontWeight: tokens.fontWeightSemibold,
        fontSize: tokens.fontSizeBase300,
        marginBottom: tokens.spacingVerticalS,
    },
    list: {
        listStyle: 'none',
        padding: 0,
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalXS,
    },
    listItem: {
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalS,
        padding: `${tokens.spacingVerticalXS} 0`,
        borderBottom: `1px solid ${tokens.colorNeutralStroke3}`,
    },
});

const SettlementDebtsInfoComponent = ({ SettlementDebts }: SettlementDebtsInfoProps) => {
    const styles = useStyles();
    return (
        <Popover trapFocus={false}>
            <PopoverTrigger>
                <Link>Ver deudas registradas</Link>
            </PopoverTrigger>
            <PopoverSurface className={styles.surface}>
                <Text className={styles.title}>Deudas registradas</Text>
                {!SettlementDebts || SettlementDebts.length === 0 ? (
                    <Text>No hay deudas registradas para esta liquidación.</Text>
                ) : (
                    <ul className={styles.list}>
                        {SettlementDebts.map((settlementDebt) => {
                            const cashFlowDebt = settlementDebt.CashFlowDebt;
                            if (!cashFlowDebt) return null;
                            const isPaid = cashFlowDebt.pendingAmount === 0;
                            const badgeColor = isPaid ? 'success' : 'danger';
                            const currency = cashFlowDebt.currencyCode?.toUpperCase() || 'ARS';
                            const hasConversion = cashFlowDebt.originalCurrencyCode &&
                                cashFlowDebt.originalCurrencyCode.toUpperCase() !== currency &&
                                cashFlowDebt.originalAmountInOriginalCurrency != null;
                            const originalCurrency = cashFlowDebt.originalCurrencyCode?.toUpperCase() || currency;
                            return (
                                <li key={`${settlementDebt.id}-${settlementDebt.debtId}`} className={styles.listItem}>
                                    <Badge appearance="filled" color={badgeColor} size="small" shape="circular" />
                                    <Text>
                                        <strong>
                                            {cashFlowDebt.originalAmount.toLocaleString('es-AR', {
                                                style: 'currency',
                                                currency
                                            })}
                                        </strong>
                                        {hasConversion && (
                                            <> ({cashFlowDebt.originalAmountInOriginalCurrency.toLocaleString('es-AR', {
                                                style: 'currency',
                                                currency: originalCurrency
                                            })})</>
                                        )}
                                        {isPaid
                                            ? ' — Pagada'
                                            : ` — Pendiente: ${cashFlowDebt.pendingAmount.toLocaleString('es-AR', {
                                                style: 'currency',
                                                currency
                                            })}`
                                        }
                                    </Text>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </PopoverSurface>
        </Popover>
    );
}
export default SettlementDebtsInfoComponent;